module.exports = __webpack_public_path__ + "static/media/puzzle-30-bg.f197a4e7.svg";